import React from "react";
// Material core components
// Material core styles
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";

// Dependencies

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import connect from "react-redux/es/connect/connect";
import { inviteUser } from "../../../../redux/actions/profileScreenActions";
import { bindActionCreators } from "redux";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import CloseIcon from '@material-ui/icons/Close';
// Actions

const styles = theme => ({
  drawerPaper: {
    zIndex: 1190,
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    },
    [theme.breakpoints.up("md")]: {
      width: "50%"
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%"
    }
  },
  radioGrid: {
    display: "inline-flex"
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1)
  }
});

class InviteUser extends React.Component {
  state = {
    email: "",
    userType: "user"
  };

  onSubmitForm = event => {
    this.props.inviteUser({
      existingUser: this.props.cognitoUser,
      invitedUser: { email: this.state.email, userType: this.state.userType }
    });
    event.preventDefault();
  };

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleRadioChange = (event, value) => {
    this.setState({ userType: value });
  };

  render() {
    const { classes, toggleRightSidebar, openDialog } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={openDialog}
          onClose={this.props.handleClose}
          aria-labelledby="form-dialog-title"
          disableBackdropClick
        >
          <DialogTitle disableTypography id="form-dialog-title">
          <Typography variant="h5">Invite User</Typography>
          <IconButton aria-label="close" className={classes.closeButton} onClick={toggleRightSidebar}>
             <CloseIcon />
          </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              Enter the email address in the form below and user will receive an invitation
            </DialogContentText>
            <form autoComplete="off" onSubmit={this.onSubmitForm}>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    autoFocus
                    id="email"
                    type="email"
                    label="Email Address:"
                    value={this.state.email}
                    onChange={this.handleChange}
                    margin="normal"
                    variant="outlined"
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} className={classes.radioGrid}>
                  <RadioGroup
                    aria-label="type"
                    name="userType"
                    value={this.state.userType}
                    onChange={this.handleRadioChange}
                    row
                    style={{ margin: "auto" }}
                  >
                    <FormControlLabel
                      value="user"
                      control={<Radio color="primary" />}
                      label="User"
                      labelPlacement="top"
                    />
                    <FormControlLabel
                      value="Administrator"
                      control={<Radio color="primary" />}
                      label="Admin"
                      labelPlacement="top"
                    />
                  </RadioGroup>
                 {/*  <Tooltip title="Send invitation">
                    <IconButton type="submit" color="secondary" style={{ margin: "auto" }}>
                      <SendIcon />
                    </IconButton>
                  </Tooltip> */}
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <Button type="submit" color="primary">
              Send Invitation    
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    cognitoUser: state.auth.cognitoUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        inviteUser
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(InviteUser));
